<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!-- <bc-btn-add
                                v-if="hasPerm('transaction_documents.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openTransactionDocumentForm"
                            ></bc-btn-add> -->
                            <bc-btn-refresh @invoke-method="dbGetTransactionDocuments(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="transaction_documents" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openTransactionDocumentForm(props.item)">
                                <td class="text-center">{{ props.item.document_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>
                                    <h5 class="mb-0">{{ props.item.ship_location_label }}</h5>
                                    <small>{{ props.item.ship_city }}, {{ props.item.ship_state }}</small>
                                </td>
                                <td class="text-center">{{ props.item.document_date }}</td>
                                <td class="text-center">{{ props.item.due_date }}</td>
                                <td class="text-center">
                                    <v-chip small :color="props.item.status_class" text-color="white">{{ props.item.status }}</v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="transaction_documents"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="transaction_document_dialog">
                <v-card>
                    <v-form ref="form_transaction_document">
                        <v-card-title>
                            <span class="headline">{{
                                transaction_document.document_id ? $t("lang.edit_transaction_document") : $t("lang.add_transaction_document")
                            }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeTransactionDocumentDialog"
                                :dialog-status="transaction_document_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="transaction_document_dialog"
                                            v-model="transaction_document.document_id"
                                            :label="`${$t('lang.document_id')} *`"
                                            :counter="showCounter(transaction_document.document_id, 'transaction_documents.document_id')"
                                            :rules="ifValid('transaction_documents.document_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.document_type"
                                            :label="$t('lang.document_type')"
                                            :counter="showCounter(transaction_document.document_type, 'transaction_documents.document_type')"
                                            :rules="ifValid('transaction_documents.document_type')"
                                        ></v-text-field>
                                    </v-flex>
                                    <!-- <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="transaction_document.device_id"
                                            :label="`${$t('lang.device_id')} *`"
                                            :items="iot_devices"
                                            item-value="device_id"
                                            item-text="device_id"
                                            :rules="ifValid('transaction_documents.device_id')"
                                        ></bc-autocomplete>
                                    </v-flex> -->
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.billing_address_id"
                                            :label="$t('lang.billing_address_id')"
                                            :counter="showCounter(transaction_document.billing_address_id, 'transaction_documents.billing_address_id')"
                                            :rules="ifValid('transaction_documents.billing_address_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.shipping_address_id"
                                            :label="$t('lang.shipping_address_id')"
                                            :counter="showCounter(transaction_document.shipping_address_id, 'transaction_documents.shipping_address_id')"
                                            :rules="ifValid('transaction_documents.shipping_address_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.ship_location_label"
                                            :label="$t('lang.ship_location_label')"
                                            :counter="showCounter(transaction_document.ship_location_label, 'transaction_documents.ship_location_label')"
                                            :rules="ifValid('transaction_documents.ship_location_label')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.ship_address1"
                                            :label="$t('lang.ship_address1')"
                                            :counter="showCounter(transaction_document.ship_address1, 'transaction_documents.ship_address1')"
                                            :rules="ifValid('transaction_documents.ship_address1')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.ship_address2"
                                            :label="$t('lang.ship_address2')"
                                            :counter="showCounter(transaction_document.ship_address2, 'transaction_documents.ship_address2')"
                                            :rules="ifValid('transaction_documents.ship_address2')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.ship_city"
                                            :label="$t('lang.ship_city')"
                                            :counter="showCounter(transaction_document.ship_city, 'transaction_documents.ship_city')"
                                            :rules="ifValid('transaction_documents.ship_city')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.ship_state"
                                            :label="$t('lang.ship_state')"
                                            :counter="showCounter(transaction_document.ship_state, 'transaction_documents.ship_state')"
                                            :rules="ifValid('transaction_documents.ship_state')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.ship_zip_code"
                                            :label="$t('lang.ship_zip_code')"
                                            :counter="showCounter(transaction_document.ship_zip_code, 'transaction_documents.ship_zip_code')"
                                            :rules="ifValid('transaction_documents.ship_zip_code')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.ship_zip_code_ext"
                                            :label="$t('lang.ship_zip_code_ext')"
                                            :counter="showCounter(transaction_document.ship_zip_code_ext, 'transaction_documents.ship_zip_code_ext')"
                                            :rules="ifValid('transaction_documents.ship_zip_code_ext')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.ship_country_iso_3"
                                            :label="$t('lang.ship_country_iso_3')"
                                            :counter="showCounter(transaction_document.ship_country_iso_3, 'transaction_documents.ship_country_iso_3')"
                                            :rules="ifValid('transaction_documents.ship_country_iso_3')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.bill_location_label"
                                            :label="$t('lang.bill_location_label')"
                                            :counter="showCounter(transaction_document.bill_location_label, 'transaction_documents.bill_location_label')"
                                            :rules="ifValid('transaction_documents.bill_location_label')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.bill_address1"
                                            :label="$t('lang.bill_address1')"
                                            :counter="showCounter(transaction_document.bill_address1, 'transaction_documents.bill_address1')"
                                            :rules="ifValid('transaction_documents.bill_address1')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.bill_address2"
                                            :label="$t('lang.bill_address2')"
                                            :counter="showCounter(transaction_document.bill_address2, 'transaction_documents.bill_address2')"
                                            :rules="ifValid('transaction_documents.bill_address2')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.bill_city"
                                            :label="$t('lang.bill_city')"
                                            :counter="showCounter(transaction_document.bill_city, 'transaction_documents.bill_city')"
                                            :rules="ifValid('transaction_documents.bill_city')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.bill_state"
                                            :label="$t('lang.bill_state')"
                                            :counter="showCounter(transaction_document.bill_state, 'transaction_documents.bill_state')"
                                            :rules="ifValid('transaction_documents.bill_state')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.bill_zip_code"
                                            :label="$t('lang.bill_zip_code')"
                                            :counter="showCounter(transaction_document.bill_zip_code, 'transaction_documents.bill_zip_code')"
                                            :rules="ifValid('transaction_documents.bill_zip_code')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.bill_zip_code_ext"
                                            :label="$t('lang.bill_zip_code_ext')"
                                            :counter="showCounter(transaction_document.bill_zip_code_ext, 'transaction_documents.bill_zip_code_ext')"
                                            :rules="ifValid('transaction_documents.bill_zip_code_ext')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.bill_country_iso_3"
                                            :label="$t('lang.bill_country_iso_3')"
                                            :counter="showCounter(transaction_document.bill_country_iso_3, 'transaction_documents.bill_country_iso_3')"
                                            :rules="ifValid('transaction_documents.bill_country_iso_3')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.shipping_carrier_id"
                                            :label="$t('lang.shipping_carrier_id')"
                                            :counter="showCounter(transaction_document.shipping_carrier_id, 'transaction_documents.shipping_carrier_id')"
                                            :rules="ifValid('transaction_documents.shipping_carrier_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="transaction_document.document_date"
                                            :label="$t('lang.document_date')"
                                            :rules="ifValid('transaction_documents.document_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="transaction_document.due_date"
                                            :label="`${$t('lang.due_date')} *`"
                                            :rules="ifValid('transaction_documents.due_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.payment_term_id"
                                            :label="`${$t('lang.payment_term_id')} *`"
                                            :counter="showCounter(transaction_document.payment_term_id, 'transaction_documents.payment_term_id')"
                                            :rules="ifValid('transaction_documents.payment_term_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="transaction_document.approved"
                                            :label="`${$t('lang.approved')} *`"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('transaction_documents.approved')"
                                        ></bc-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.currency_id"
                                            :label="`${$t('lang.currency_id')} *`"
                                            :counter="showCounter(transaction_document.currency_id, 'transaction_documents.currency_id')"
                                            :rules="ifValid('transaction_documents.currency_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.exchange_rate"
                                            :label="`${$t('lang.exchange_rate')} *`"
                                            :counter="showCounter(transaction_document.exchange_rate, 'transaction_documents.exchange_rate')"
                                            :rules="ifValid('transaction_documents.exchange_rate')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.status_id"
                                            :label="`${$t('lang.status_id')} *`"
                                            :counter="showCounter(transaction_document.status_id, 'transaction_documents.status_id')"
                                            :rules="ifValid('transaction_documents.status_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.work_order_no"
                                            :label="$t('lang.work_order_no')"
                                            :counter="showCounter(transaction_document.work_order_no, 'transaction_documents.work_order_no')"
                                            :rules="ifValid('transaction_documents.work_order_no')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.subtotal"
                                            :label="$t('lang.subtotal')"
                                            :counter="showCounter(transaction_document.subtotal, 'transaction_documents.subtotal')"
                                            :rules="ifValid('transaction_documents.subtotal')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.discount"
                                            :label="$t('lang.discount')"
                                            :counter="showCounter(transaction_document.discount, 'transaction_documents.discount')"
                                            :rules="ifValid('transaction_documents.discount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.discount_type"
                                            :label="`${$t('lang.discount_type')} *`"
                                            :counter="showCounter(transaction_document.discount_type, 'transaction_documents.discount_type')"
                                            :rules="ifValid('transaction_documents.discount_type')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.freight"
                                            :label="$t('lang.freight')"
                                            :counter="showCounter(transaction_document.freight, 'transaction_documents.freight')"
                                            :rules="ifValid('transaction_documents.freight')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.expedite_fee"
                                            :label="$t('lang.expedite_fee')"
                                            :counter="showCounter(transaction_document.expedite_fee, 'transaction_documents.expedite_fee')"
                                            :rules="ifValid('transaction_documents.expedite_fee')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.handling_charge"
                                            :label="$t('lang.handling_charge')"
                                            :counter="showCounter(transaction_document.handling_charge, 'transaction_documents.handling_charge')"
                                            :rules="ifValid('transaction_documents.handling_charge')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.customs"
                                            :label="$t('lang.customs')"
                                            :counter="showCounter(transaction_document.customs, 'transaction_documents.customs')"
                                            :rules="ifValid('transaction_documents.customs')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.total_amount"
                                            :label="$t('lang.total_amount')"
                                            :counter="showCounter(transaction_document.total_amount, 'transaction_documents.total_amount')"
                                            :rules="ifValid('transaction_documents.total_amount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.balance"
                                            :label="`${$t('lang.balance')} *`"
                                            :counter="showCounter(transaction_document.balance, 'transaction_documents.balance')"
                                            :rules="ifValid('transaction_documents.balance')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.document_subtotal"
                                            :label="`${$t('lang.document_subtotal')} *`"
                                            :counter="showCounter(transaction_document.document_subtotal, 'transaction_documents.document_subtotal')"
                                            :rules="ifValid('transaction_documents.document_subtotal')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.document_discount"
                                            :label="`${$t('lang.document_discount')} *`"
                                            :counter="showCounter(transaction_document.document_discount, 'transaction_documents.document_discount')"
                                            :rules="ifValid('transaction_documents.document_discount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.document_freight"
                                            :label="`${$t('lang.document_freight')} *`"
                                            :counter="showCounter(transaction_document.document_freight, 'transaction_documents.document_freight')"
                                            :rules="ifValid('transaction_documents.document_freight')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.document_expedite_fee"
                                            :label="`${$t('lang.document_expedite_fee')} *`"
                                            :counter="showCounter(transaction_document.document_expedite_fee, 'transaction_documents.document_expedite_fee')"
                                            :rules="ifValid('transaction_documents.document_expedite_fee')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.document_handling_charge"
                                            :label="`${$t('lang.document_handling_charge')} *`"
                                            :counter="
                                                showCounter(transaction_document.document_handling_charge, 'transaction_documents.document_handling_charge')
                                            "
                                            :rules="ifValid('transaction_documents.document_handling_charge')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.document_customs"
                                            :label="`${$t('lang.document_customs')} *`"
                                            :counter="showCounter(transaction_document.document_customs, 'transaction_documents.document_customs')"
                                            :rules="ifValid('transaction_documents.document_customs')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.document_total_amount"
                                            :label="`${$t('lang.document_total_amount')} *`"
                                            :counter="showCounter(transaction_document.document_total_amount, 'transaction_documents.document_total_amount')"
                                            :rules="ifValid('transaction_documents.document_total_amount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.customer_po"
                                            :label="$t('lang.customer_po')"
                                            :counter="showCounter(transaction_document.customer_po, 'transaction_documents.customer_po')"
                                            :rules="ifValid('transaction_documents.customer_po')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="transaction_document.comments"
                                            :label="$t('lang.comments')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('transaction_documents.comments')"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="transaction_document.department_id"
                                            :label="$t('lang.department_id')"
                                            :counter="showCounter(transaction_document.department_id, 'transaction_documents.department_id')"
                                            :rules="ifValid('transaction_documents.department_id')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="transaction_document.document_id" color="error" @mouseup.left="$refs.delete_transaction_documents.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeTransactionDocumentDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveTransactionDocuments">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_transaction_documents"
                :heading="$t('lang.delete_transaction_document')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteTransactionDocuments(transaction_document.document_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openTransactionDocumentForm" },
                { title: this.$t("lang.refresh"), action: "dbGetTransactionDocuments", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.order_number"), sortable: false, width: "2%", align: "center" },
                { text: this.$t("lang.company"), sortable: false, width: "2%" },
                { text: this.$t("lang.delivery_location"), sortable: false, width: "2%" },
                { text: this.$t("lang.order_date"), sortable: false, width: "2%", align: "center" },
                { text: this.$t("lang.expected_delivery_date"), sortable: false, width: "2%", align: "center" },
                { text: this.$t("lang.status"), sortable: false, width: "2%", align: "center" },
            ],
            enableAddModal: false,
            enableEditModal: false,

            transaction_document: {},
            filter: {
                search: "",
                status: "1",
            },
            transaction_document_dialog: false,
            dbGetTransactionDocuments: _.debounce(this.getTransactionDocuments, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchTransactionDocuments", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.transaction_documents) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchTransactionDocuments({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.transaction_documents) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.transaction_documents.transaction_documents_filter,
            page: (state) => state.transaction_documents.page,
            rules_transaction_documents: (state) => state.transaction_documents.rules_transaction_documents,
            transaction_document_status_options: (state) => state.settings.transaction_document_status_options,
            transaction_documents: (state) => state.transaction_documents.transaction_documents,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchTransactionDocuments", "saveTransactionDocument", "deleteTransactionDocument"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openTransactionDocumentForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_transaction_document)
                        item ? this.$refs.form_transaction_document.resetValidation() : this.$refs.form_transaction_document.reset();

                    this.$nextTick(() => {
                        this.transaction_document = item != null ? this.assignObj2(item, this.rules_transaction_documents) : {};
                        this.transaction_document_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "transaction_document", params: { id: item.document_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_transaction_document)
                        item ? this.$refs.form_transaction_document.resetValidation() : this.$refs.form_transaction_document.reset();
                    this.transaction_document_dialog = true;
                } else {
                    this.$router.push({ name: "transaction_document" });
                }
            }
        },
        saveTransactionDocuments() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_transaction_document")) {
                    let body = this.prepForm(this.transaction_document, this.rules_transaction_documents);

                    this.saveTransactionDocument({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getTransactionDocuments();
                                this.closeTransactionDocumentDialog();
                            } else {
                                this.$router.push({ name: "transaction_document", params: { id: data.document_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteTransactionDocuments(id = null) {
            this.deleteTransactionDocument({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getTransactionDocuments();
                    this.closeTransactionDocumentDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeTransactionDocumentDialog() {
            this.transaction_document_dialog = false;
            this.$refs.delete_transaction_documents.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getTransactionDocuments(pg_refresh = false) {
            this.startLoader();

            this.fetchTransactionDocuments({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.transaction_document_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
    },
};
</script>
